<template>
    <div class="common-problems">
      <benefit :benefit-content="content"></benefit>
    </div>
</template>

<script>
// import titleBar from "@/components/common/titleBar.vue";
import  Benefit from "@/components/Benefit/Benefit";
export default {
  name: "",
  data() {
    return {
      content: [{
          id:1001,
          question: "1、会员享受的权益有什么？后续会增加吗？",
          answer:["特权一：自学板块优质内容免费学，包含全部绘本、优质轻课、趣味音频；","特权二：趣味学习工具免费用，包含三科同步练（语文、数学、英语）、速算闯关、魔法学院、学霸计划、成语学堂；","特权三：会员增值权益，包括会员专属皮肤、学贝双倍积分等。",
                "目前会员尊享以上三大权益。小盒会员仍在不断升级和完善，内容板块音视频及绘本会定期上架更新，同时还会不断扩充的其他会员权益。"]
      },{
          id:'1002',
          question: "2、ios用户如何取消自动续费？",
          answer:["对ios苹果支付：打开苹果手机【设置】→进入【iTunes store 与 App Store】→点击【Apple ID】→选择【查看Apple ID】→【账户设置】页面→点击订阅→选择小盒学习会员取消订阅即可（此方法适用大多数苹果设备，但因苹果设备型号不同操作不同，如上述方法无法取消，请联系苹果客服取消订阅）。"]
      },{
          id:1003,
          question: "3、Android用户如何取消自动续费？",
          answer:["对支付宝支付：打开支付宝【我的-设置】→进入【支付设置】→点击【免密支付/自动扣款】，选择小盒学习会员取消订阅即可；","对微信支付：打开微信【我】→点击【支付】→点击右上角【···】→点击【扣费服务】选择小盒学习→【关闭服务】即可。"]
      },{
          id:1004,
          question: "4、开通会员后是否可以退款？售后问题如何解决？",
          answer:["会员属于虚拟商品，一经开通不可退款，如有其他问题请联系客服。","客服电话：4000 100 180","工作时间：周一至周日  08:00-22:00"]
      },
      ],
      // title: '常见问题'
    };
  },
  components: {
    Benefit
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
  .common-problems {
    margin-top: 10px
  }
</style>